( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function AddEditTimerController ( $scope, $rootScope, logger, evidence, observation, level, $filter, $timeout, $modalInstance, apiService, TOOLTIP_MESSAGES ) {
		/* eslint-enable max-params */
		var self   = this;

		self.title = 'AddEditTimerController';

		var quickAccess, changeTimeReceiver;

		function startTimerHandler () {
			self.startStopLabel = 'Stop';
			self.startTimer     = false;
			self.tempStartTime  = false;

			$rootScope.$broadcast( 'start:time:', self.evidence.id );
		}

		function setTimeText ( time ) {
			angular.element( '#add-timer-' + self.evidence.id ).text( time );
			self.time = time;
		}

		function stopTimerHandler () {
			self.startStopLabel = 'Start';
			self.startTimer     = true;

			$rootScope.$broadcast( 'stop:time:', self.evidence.id );
		}

		function clearTimerHandler () {
			$rootScope.$broadcast( 'clear:time:', self.evidence.id, true );
		}

		function closeView () {
			$modalInstance.close();
		}

		function saveEvidence () {
			self.evidence.name        = self.name;
			self.evidence.description = self.time;

			if ( !level.evidences ) {
				level.evidences = [ ];
			}

			level.evidences.push( angular.copy( self.evidence ) );

			if ( !observation.masterEvidences ) {
				observation.masterEvidences = [ ];
			}

			observation.masterEvidences.push( angular.copy( self.evidence ) );

			quickAccess = {
				'activeTimer'  : false,
				'type'         : 7,
				'evidenceData' : self.evidence,
				'fromAdd'      : {
					'startTimer' : self.startTimer
				}
			};

			$rootScope.$broadcast( 'quick:access:collapse' );
			$rootScope.$broadcast( 'updateObs', quickAccess );
			closeView();
		}

		function cancelChanges () {
			$rootScope.$broadcast( 'delete:timer', self.evidence.id );
			$modalInstance.dismiss();
		}

		function startStopHandler () {
			if ( self.startTimer ) {
				startTimerHandler();
			} else {
				stopTimerHandler();
			}
		}

		function activate () {
			logger.info( 'Activated Add/Edit Timer Controller' );

			self.evidence = {
				'id'          : apiService.generateUUID(),
				'name'        : '',
				'description' : '00:00:00.00',
				'type'        : 7,
				'scope'       : 'public'
			};

			$timeout( function () {
				setTimeText( '00:00:00.00' );
			}, 1 );

			self.startTimer       = true;
			self.name             = 'Timer';
			self.startStopLabel   = 'Start';
			self.startStopHandler = startStopHandler;
			self.showLoading      = false;

			changeTimeReceiver = 'change:time:' + self.evidence.id;

			$rootScope.$broadcast( 'add:timer', self.evidence, self.startTimer );
		}

		self.startTimerHandler = startTimerHandler;
		self.stopTimerHandler  = stopTimerHandler;
		self.closeView         = closeView;
		self.saveEvidence      = saveEvidence;
		self.cancelChanges     = cancelChanges;
		self.clearTimerHandler = clearTimerHandler;
		self.tooltip           = TOOLTIP_MESSAGES;

		activate();

		$modalInstance.result.catch( function () {
			$rootScope.$broadcast( 'stop:time:', self.evidence.id );
		} );

		$rootScope.$on( 'close:add:modal', function () {
			closeView();
		} );

		$rootScope.$on( changeTimeReceiver, function ( ev, updatedTime ) {
			setTimeText( updatedTime );
		} );
	}

	angular
		.module( 'app.components' )
		.controller( 'AddEditTimerController', AddEditTimerController );

	AddEditTimerController.$inject = [ '$scope', '$rootScope', 'logger', 'evidence', 'observation', 'level', '$filter', '$timeout', '$modalInstance', 'apiService', 'TOOLTIP_MESSAGES' ];
} )( );
